var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-tags"},_vm._l((_vm.selectedTags),function(tag){return _c('div',{key:tag.id,staticClass:"tag-container"},[_c('span',{staticClass:"tag-text"},[_vm._v(_vm._s(tag.value))]),_c('span',{staticClass:"tag-close",on:{"click":function($event){return _vm.removeTag(tag.id)}}},[_c('i',{staticClass:"si si-cross"})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }